import { IDisposable } from 'rx'
import { getAccountTopic } from '@mobi/utils/awsiot/topics'
import { balanceUpdate, payIdUpdate, withdrawChannelUpdate } from '@mobi/account/Utils/iotEvents'
import { invalidateRacingPendingTicketsQueryData } from '@core/Data/Account/PendingTicketsCount/helpers/invalidation'
import { queryClient } from '@core/Data/ReactQuery/queryClient'
import {
  iotSubscribeTopics,
  iotUnsubscribeTopics,
  isAccountBalanceChangedPushEvent,
} from '../PushData'
import { state$ as userAccountState$ } from './userAccountDriver'
import { fetchAccountBalanceAsync } from './async-signals'

let pushDataSubscription: IDisposable | null = null

export const register = (): void => {
  let accountNumberLoggedIn: number | null = null

  userAccountState$
    .map(({ isLoggedIn, accountNumber }) => ({
      isLoggedIn,
      accountNumber,
    }))
    .distinctUntilChanged()
    .subscribe(({ isLoggedIn, accountNumber }) => {
      // Do initial fetch and set up subscription
      if (isLoggedIn && !pushDataSubscription) {
        subscribe(accountNumber as number)
      }
      // Unsubscribe and dispose of subscription
      if (!!pushDataSubscription && !isLoggedIn) {
        unsubscribe()
      }
    })

  function subscribe(accountNumber: number) {
    accountNumberLoggedIn = accountNumber

    const pushEventSubscription = iotSubscribeTopics([getAccountTopic(accountNumber)])
    pushDataSubscription = pushEventSubscription.subscribe(({ payload }) => {
      if (!payload) return

      if (isAccountBalanceChangedPushEvent(payload) && payload.transactionType === 'Payout') {
        invalidateRacingPendingTicketsQueryData()
      }

      balanceUpdate(payload, queryClient, fetchAccountBalanceAsync)
      payIdUpdate(payload, accountNumber, queryClient)
      withdrawChannelUpdate(payload)
    })
  }

  function unsubscribe() {
    if (accountNumberLoggedIn === null) {
      return
    }

    iotUnsubscribeTopics([getAccountTopic(accountNumberLoggedIn)])
    if (!!pushDataSubscription && pushDataSubscription.dispose) {
      pushDataSubscription.dispose()
      pushDataSubscription = null
    }
  }
}
